const DOCK_SELECTOR_CLASS = "js-dock"; // Assign this to your static (in liquid) dock element
const STICKY_STATE_CLASS = "has-shadow";
// Map to store & relate observed dock to its container element
const observedDockMap = new WeakMap();
const dockContainerObserver = new ResizeObserver((entries) => {
    // Wrap it in requestAnimationFrame to avoid "ResizeObserver loop limit exceeded" errors
    window.requestAnimationFrame(() => {
        entries.forEach((entry) => {
            const dockContainer = entry.target;
            if (!dockContainer || !(dockContainer instanceof HTMLElement))
                return;
            const dock = observedDockMap.get(dockContainer);
            if (!dock || !(dock instanceof HTMLElement))
                return;
            const isContentOverflowing = dockContainer.scrollHeight > window.innerHeight;
            if (isContentOverflowing) {
                dock.classList.add(STICKY_STATE_CLASS);
            }
            else {
                dock.classList.remove(STICKY_STATE_CLASS);
            }
        });
    });
});
function handleStaticDocks() {
    const docks = document.querySelectorAll(`.${DOCK_SELECTOR_CLASS}`);
    docks.forEach((dock) => {
        const containerId = dock.dataset.containerId || null;
        initDock(dock, containerId);
    });
}
export function initDock(el, containerId = null) {
    const container = containerId
        ? document.getElementById(containerId)
        : el.parentElement;
    if (el && container) {
        observedDockMap.set(container, el);
        dockContainerObserver.observe(container);
    }
}
export function unobserveDock(el, containerId = null) {
    const container = containerId
        ? document.getElementById(containerId)
        : el.parentElement;
    if (el && container) {
        observedDockMap.delete(container);
        dockContainerObserver.unobserve(container);
    }
}
/**
 * Dock.
 */
export default {
    init: function () {
        handleStaticDocks();
    },
};
